import { TableBody, TableCell, TableRow } from "@/components/ui/table";
import { flexRender } from "@tanstack/react-table";
import { Loader2 } from "lucide-react";

export default function ProductTableBody({
    table,
    isLoadingPage,
    columns,
    isLoadingProducts,
}: {
    table: any;
    isLoadingPage: boolean;
    columns: any;
    isLoadingProducts: boolean;
}) {
    return (
        <TableBody>
            {table.getRowModel().rows?.length ? (
                table.getRowModel().rows.map((row: any) => (
                    <TableRow
                        key={row.id}
                        className={isLoadingPage ? "opacity-50" : ""}
                    >
                        {row.getVisibleCells().map((cell: any) => (
                            <TableCell key={cell.id}>
                                {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                ))
            ) : (
                <TableRow>
                    <TableCell
                        colSpan={columns.length}
                        className="h-24 text-center"
                    >
                        {isLoadingProducts ? (
                            <div className="flex items-center justify-center gap-2">
                                <Loader2 className="h-4 w-4 animate-spin" />
                                Loading products...
                            </div>
                        ) : (
                            "No results."
                        )}
                    </TableCell>
                </TableRow>
            )}
        </TableBody>
    );
}
